module.exports = __webpack_public_path__ + "static/p07_borregoL-f7f1936c29fec0672d2c49e0aa089f42.png";